<template>
  <mu-card id="lessonQuiz">
    <mu-row>
      <mu-col width="30" desktop="30" tablet="30" class="lightbulb-icon quizBg">
        <mu-flexbox justify="center" align="center" style="height: 244px;">
          <mu-flexbox-item align="center">
            <img width="116px" height="100%" src="static/lesson/lightbulb.svg"/>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-col>
      <mu-col width="100" desktop="70" tablet="70">
        <mu-flexbox align="center" orient="vertical">
          <mu-flexbox-item>
            <mu-card-text v-if="!isQuizComplete">
              <div class="question" v-for="(item, index) in quiz" :key="'quiz-' + index"
                   v-show="questionNumberIndex === index">
                <div class="blueTitle largeTitle">{{$t('message.quizTestKnowledge')}}</div>
                <div class="bottom"
                     v-text="$t('message.questionText')  + ' '  + (index + 1) + ': ' + item.question"></div>
                <div
                  v-text="(item.correct === 1) ? $t('message.selectText') + ' ' + item.correct + ' ' + $t('message.answerText') : 'Please select ' + item.correct + ' ' + $t('message.answersText')"></div>
                <br/>
                <div class="answers">
                  <div class="answer" v-for="(answer, answerIndex) in item.answers" :key="'quiz-answer-' + answerIndex">
                    <mu-checkbox
                      :label="answer.answer"
                      v-model="activeAnswerStore"
                      :nativeValue="'' + answer.answer_id + ''"
                      :disabled="activeAnswerStore.length >= activeQuestion.correct && activeAnswerStore.indexOf('' + '' + answer.answer_id + '' + '') === -1"
                      slot="left"
                    ></mu-checkbox>
                  </div>
                </div>
              </div>
            </mu-card-text>
            <mu-card-text v-if="isQuizComplete">
              <div class="blueTitle largeTitle">{{$t('message.quizComplete')}}</div>
              <p>{{percentage}}&percnt;.</p>
            </mu-card-text>
          </mu-flexbox-item>
          <mu-flexbox-item>
            <mu-divider></mu-divider>
            <mu-card-actions align="right">
              <!-- Only show when quiz wasn't finished --->
              <mu-raised-button
                v-if="isQuizComplete === false"
                @click.native="nextQuestion()"
                type="button"
                :disabled="( questions !== questionNumberIndex ) && activeAnswerStore.length !== activeQuestion.correct"
                secondary
                :label="markable.length === totalCorrectAnswers ? $t('message.finishText') : $t('message.nextText')">
              </mu-raised-button>
              <mu-raised-button
                v-if="isQuizComplete === true"
                @click.native="startAgain()"
                type="button"
                secondary
                :label="$t('message.labelTryAgain')">
              </mu-raised-button>
            </mu-card-actions>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-col>
    </mu-row>
  </mu-card>
</template>
<script>


  import LessonApi from './../../../api/Lessons'

  export default {
    name: "lesson-quiz-panel",
    props: {
      quiz: {
        type: Array
      },
      course_id: {
        type: Number
      },
      quiz_id: {
        type: Number
      }
    },
    data() {
      return {
        isQuizComplete: false,
        percentage: 0,
        questions: 0,
        questionNumberIndex: 0,
        activeAnswerStore: [],
        markable: []
      }
    },
    mounted() {
      let self = this;
      self.questions = self.quiz.length;
    },
    computed: {
      activeQuestion() {
        return this.quiz[this.questionNumberIndex]
      },
      totalCorrectAnswers() {
        return this.quiz.map(x => x.correct)
          .reduce((a, b) => a + b)
      }
    },
    methods: {
      startAgain() {
        let self = this;
        self.isQuizComplete = false;
        self.percentage = 0;
        self.activeAnswerStore = [];
        self.markable = [];
        self.questionNumberIndex = 0;
      },
      getQuizResults() {
        // spoke to giv, not going to show results to the user
        // just something like "you got 30% correct, click retry to try again"
      },
      addAnswersToMarkable() {
        let self = this;
        for (let item of self.activeAnswerStore) {
          self.markable.push({
            question_id: self.activeQuestion.question_id,
            answer_id: item
          })
        }
        self.activeAnswerStore = [];
      },
      nextQuestion() {
        let self = this;
        if (self.activeAnswerStore.length === 0) {
          return;
        }

        self.addAnswersToMarkable();

        if (this.questionNumberIndex === this.quiz.length) {
          self.finishQuiz();
          return;
        }

        if (self.markable.length === self.totalCorrectAnswers && !self.isQuizComplete) {
          self.finishQuiz();
        } else {
          self.questionNumberIndex++;
        }
      },
      finishQuiz() {
        let self = this;
        const model = {
          course_id: self.course_id,
          quiz_id: self.quiz_id,
          selectedAnswers: self.markable
        };
        LessonApi.saveQuizResult(model).then((response) => {
          self.isQuizComplete = true;
          self.percentage = response.data.percentage.toFixed(0);
        }).catch((error) => {
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  #lessonQuiz {
    .lightbulb-icon {
      padding: 32px;
    }

    .quizBg {
      background: url('/static/lesson/quiz-bg.svg');
    }
  }

  @media only screen and (max-width: 600px) {
    #lessonQuiz {
      .lightbulb-icon {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// QuizPanel.vue?5f68af71